import type { Member } from '@aibees/shared/definition';
import type { AdvanceTableActionProps } from '@aibees/shared/features';

export interface TeamMemberEditActionProps
  extends AdvanceTableActionProps<Member> {
  className?: string;
}

export enum TeamMemberActionType {
  editRole = 'editRole',
  activate = 'activate',
  deactivate = 'deactivate',
  reactivate = 'reactivate',
  resend = 'resend',
  delete = 'delete',
  changeOwnership = 'changeOwnership',
  cancelInvite = 'cancelInvite',
  cancelTransfer = 'cancelTransfer',
  creditCap = 'creditCap',
  creditUsage = 'creditUsage',
}
